import SweetModal from './components/SweetModal'
import SweetModalTab from './components/SweetModalTab'

export {
	SweetModal,
	SweetModalTab
}



//////////////////
// WEBPACK FOOTER
// ./~/sweet-modal-vue/src/main.js
// module id = 28
// module chunks = 0